import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { clone } from 'ramda'
import ValidatedReceiptsActions, { ValidatedReceiptsRedux, ValidatedReceiptsTypes } from '../Redux/ValidatedReceiptsRedux'
import BalanceActions from '../Redux/BalanceRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'


const validatedReceiptsCrudObservable = createCRUDObservable({
  mainRedux: ValidatedReceiptsRedux,
  reduxPath: 'validatedReceipts',
  dataHandlers: {
    get: response => response.data,
  },
})

const unvalidateEpic = (action$, store, { Api }) =>
  action$.ofType(ValidatedReceiptsTypes.unvalidateRequest)
    .mergeMap(({ id: receiptId, body }) => (
      Observable
        .fromPromise(Api.validatedReceipts.unvalidate(receiptId, body)
          .then(result => result)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              ValidatedReceiptsActions.unvalidateFailure(response.error),
              notificationFail(response.error),
            ]
          }

          let receipts = clone(store.getState().validatedReceipts.get.results.data)
          let found;
          if(receipts === undefined || receipts === null){
            receipts = clone(store.getState().balance.receipts.results)
            found = receipts.find(receipt => receipt.id === receiptId)
            receipts.splice(receipts.indexOf(found), 1);
            return[
              BalanceActions.getUnvalidatedReceiptsSuccess(receipts),
            ]
          }
            found = receipts.find(receipt => receipt.id === receiptId)
            found.validated_at = null
          return [
            ValidatedReceiptsActions.unvalidateSuccess(receipts),
          ]
        })
    ))

export const validatedReceiptsObservers = Object.assign({},
  validatedReceiptsCrudObservable.observers, {
  })

export const validatedReceiptsEpic = combineEpics(
  validatedReceiptsCrudObservable.epic,
  unvalidateEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ValidatedReceiptsObservable.js